'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconArrowExpanderDown, iconArrowExpanderDownTag } from '@ni/nimble-components/dist/esm/icons/arrow-expander-down';
import { wrap } from '../../utilities/react-wrapper';

export type { IconArrowExpanderDown };
export { iconArrowExpanderDownTag };
export const NimbleIconArrowExpanderDown = wrap(IconArrowExpanderDown);